import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c5dcac44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-red"
}
const _hoisted_2 = { class: "flex align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "to", -1))
const _hoisted_4 = {
  class: "flex col grow",
  style: {"width":"80vw","max-width":"400px"}
}
const _hoisted_5 = {
  class: "flex col grow",
  style: {"width":"80vw","max-width":"500px"}
}
const _hoisted_6 = { class: "flex col" }
const _hoisted_7 = { class: "flex justify-between align-center" }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { class: "grid single" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "flex col" }
const _hoisted_12 = { class: "main-layout" }
const _hoisted_13 = { class: "container grow" }
const _hoisted_14 = { class: "flex col grow" }
const _hoisted_15 = { class: "flex g12 justify-between" }
const _hoisted_16 = { class: "flex align-center wrap" }
const _hoisted_17 = { class: "flex align-center justify-between" }
const _hoisted_18 = {
  key: 0,
  class: "edit-btn"
}
const _hoisted_19 = { class: "bold" }
const _hoisted_20 = {
  class: "flex justify-end align-center no-mobile",
  style: {"height":"60px"}
}
const _hoisted_21 = { class: "flex justify-between" }
const _hoisted_22 = { class: "panel grow" }
const _hoisted_23 = { class: "flex justify-between wrap" }
const _hoisted_24 = { class: "flex justify-between align-center p0y" }
const _hoisted_25 = { class: "block-title bold f14" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block-title bold f14" }, " Recurrence ", -1))
const _hoisted_27 = { class: "flex justify-between wrap" }
const _hoisted_28 = { class: "flex justify-between align-center p0y" }
const _hoisted_29 = { class: "block-title bold f14" }
const _hoisted_30 = { class: "flex row g12 grow wrap" }
const _hoisted_31 = { class: "panel flex col g12 panel-cmp" }
const _hoisted_32 = { class: "flex justify-between align-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block-title bold f14" }, "Module ", -1))
const _hoisted_34 = { class: "flex align-center justify-between" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "subtitle" }
const _hoisted_37 = { class: "flex col grow justify-between align-center" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_40 = { class: "flex justify-between" }
const _hoisted_41 = { class: "subtitle" }
const _hoisted_42 = { class: "flex justify-between" }
const _hoisted_43 = { class: "subtitle" }
const _hoisted_44 = { class: "grid single grid-overflow" }
const _hoisted_45 = { class: "grow flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_RRuleInput = _resolveComponent("RRuleInput")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeColorPicker = _resolveComponent("SeColorPicker")!
  const _component_ElementSelectList = _resolveComponent("ElementSelectList")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeForm = _resolveComponent("SeForm")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeTextarea = _resolveComponent("SeTextarea")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_TaskActionList = _resolveComponent("TaskActionList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "scheduleModal",
      title: _ctx.Lang.getI18N('schedule')
    }, {
      default: _withCtx(() => [
        (_ctx.scheduleStart > _ctx.scheduleEnd)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.Lang.getI18N("schedule-incoherent")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_VDatePicker, {
            is24hr: "",
            "hide-time-header": "",
            modelValue: _ctx.scheduleStart,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scheduleStart) = $event)),
            mode: "time"
          }, null, 8, ["modelValue"]),
          _hoisted_3,
          _createVNode(_component_VDatePicker, {
            is24hr: "",
            "hide-time-header": "",
            modelValue: _ctx.scheduleEnd,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scheduleEnd) = $event)),
            mode: "time"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_SeButton, {
            class: "modal-valid",
            onPress: _ctx.addOrEditSchedule,
            icon: "/ico/edit.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      ref: "modal",
      title: "Infos"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("task-action-required")), 1)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: "Recurrence",
      ref: "rruleModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RRuleInput, {
          style: {"min-width":"80vw"},
          ref: "rruleInput"
        }, null, 512),
        _createVNode(_component_SeButton, {
          onPress: _ctx.closeRRuleModal,
          class: "w100 modal-valid"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add'),
      ref: "addActionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SeInput, {
            ref: "actionName",
            placeholder: _ctx.Lang.getI18N('action-name')
          }, null, 8, ["placeholder"]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.addAction,
            class: "w100 modal-valid",
            icon: "ico/plus.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('modify'),
      ref: "modifyActionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_SeInput, {
            ref: "actionNameMod",
            placeholder: _ctx.Lang.getI18N('action-name')
          }, null, 8, ["placeholder"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Lang.getI18N("attachments")), 1),
              _createVNode(_component_SeFadeButton, {
                onClick: _ctx.uploadAttachment,
                icon: "/ico/upload-blue.svg"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Upload")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionAttachments, (attachment) => {
                return (_openBlock(), _createBlock(_component_WideCard, {
                  icon: "/ico/link.svg",
                  highlight: true,
                  selected: true,
                  title: _ctx.StringUtils.truncateText(attachment.name, 20)
                }, {
                  subtitle: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(attachment.type), 1)
                  ]),
                  footer: _withCtx(() => [
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.moveDownAttachement(attachment),
                      icon: "/ico/arrow-minimalistic-down.svg"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.moveUpAttachement(attachment),
                      icon: "/ico/arrow-minimalistic-up.svg"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.downloadAttachement(attachment),
                      icon: "/ico/download.svg"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_SeFadeButton, { icon: "/ico/edit-blue.svg" }),
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.deleteAttachement(attachment),
                      icon: "/ico/trash.svg"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 256))
            ])
          ]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.modifyAction,
            class: "modal-valid w100",
            icon: "ico/edit.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("modify")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add'),
      ref: "taskTypeModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_SeInput, {
            ref: "taskTypeName",
            placeholder: _ctx.Lang.getI18N('name')
          }, null, 8, ["placeholder"]),
          _createVNode(_component_SeColorPicker, { ref: "colorPicker" }, null, 512),
          _createVNode(_component_SeButton, {
            onPress: _ctx.modifyOrCreateTaskType,
            class: "modal-valid w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("apply")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('modify'),
      ref: "addElementModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElementSelectList, {
          ref: "elementSelect",
          validElements: _ctx.validElements,
          selectedElements: _ctx.selectedElements,
          store: true,
          module: _ctx.state.selectedModule!
        }, null, 8, ["validElements", "selectedElements", "module"]),
        _createVNode(_component_SeButton, {
          style: {"margin-top":"24px","margin-bottom":"24px","width":"100px"},
          onPress: _ctx.addElements,
          class: "modal-valid"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Ok ")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        title: _ctx.state.taskConfiguration!.getName()
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_SeForm, {
              ref: "submitForm",
              class: "flex g10 justify-end"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_ReadonlyField, {
                    class: "grow",
                    locked: _ctx.state.taskConfiguration!.originValue?.name_lock
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SeInput, {
                        id: "taskName",
                        style: {"width":"300px","max-width":"50vw"},
                        class: "grow",
                        required: "",
                        placeholder: _ctx.Lang.getI18N('name'),
                        value: _ctx.state.taskConfiguration!.getName(),
                        modelValue: _ctx.state.taskConfiguration!.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.taskConfiguration!.name) = $event))
                      }, null, 8, ["placeholder", "value", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["locked"]),
                  (!_ctx.state.creation)
                    ? (_openBlock(), _createBlock(_component_SeButton, {
                        key: 0,
                        ref: "duplicateBtn",
                        onPress: _ctx.duplicate,
                        class: "no-pc",
                        icon: "ico/copy.svg"
                      }, null, 8, ["onPress"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_SeButton, {
                    onPress: _ctx.apply,
                    ref: "applyBtn",
                    class: "no-pc",
                    icon: "ico/save.svg"
                  }, null, 8, ["onPress"]),
                  _createVNode(_component_ReadonlyField, {
                    class: "grow",
                    locked: _ctx.state.taskConfiguration!.originValue?.type_lock
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SeDropdown, {
                        nullable: true,
                        modelValue: _ctx.state.selectedTaskType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.selectedTaskType) = $event)),
                        titleFunc: (actionType) => actionType.name,
                        ref: "typeSelect",
                        class: "grow"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.taskTypes, (taskActionType) => {
                            return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                              displayTitle: false,
                              value: taskActionType
                            }, {
                              heading: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", {
                                    class: "color-chip",
                                    style: _normalizeStyle('background-color:' + taskActionType.color)
                                  }, null, 4),
                                  _createElementVNode("span", null, _toDisplayString(taskActionType.name), 1)
                                ])
                              ]),
                              tailing: _withCtx(() => [
                                (taskActionType.storeSide)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode(_component_SeImage, {
                                        onClick: () => _ctx.openEditTaskTypeModal(taskActionType),
                                        maxWidth: 18,
                                        maxHeight: 18,
                                        src: "/ico/edit-blue.svg"
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 256)),
                          _createVNode(_component_SeDropdownItem, {
                            displayTitle: false,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openTaskTypeModal())),
                            class: "noselect"
                          }, {
                            heading: _withCtx(() => [
                              _createElementVNode("span", _hoisted_19, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "titleFunc"])
                    ]),
                    _: 1
                  }, 8, ["locked"])
                ])
              ]),
              _: 1
            }, 512),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ReadonlyField, {
                locked: _ctx.state.taskConfiguration!.originValue?.active_lock
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ToggleSwitch, {
                    style: {"margin-left":"auto","margin-right":"0"},
                    ref: "switch",
                    modelValue: _ctx.state.taskConfiguration!.active,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.taskConfiguration!.active) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["locked"]),
              (!_ctx.state.creation)
                ? (_openBlock(), _createBlock(_component_SeButton, {
                    key: 0,
                    ref: "duplicateBtn",
                    onPress: _ctx.duplicate,
                    icon: "ico/copy.svg",
                    class: "no-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("duplicate")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"]))
                : _createCommentVNode("", true),
              _createVNode(_component_SeButton, {
                class: "no-mobile",
                onPress: _ctx.apply,
                tooltip: _ctx.Lang.getI18N('save'),
                ref: "applyBtn",
                icon: "ico/save.svg"
              }, null, 8, ["onPress", "tooltip"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_ReadonlyField, {
                class: "flex grow",
                locked: _ctx.state.taskConfiguration!.originValue?.description_lock
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SeTextarea, {
                    placeholder: "Description",
                    id: "taskDescription",
                    modelValue: _ctx.state.taskConfiguration!.description,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.taskConfiguration!.description) = $event)),
                    defaultValue: _ctx.state.taskConfiguration!.getDescription()
                  }, null, 8, ["modelValue", "defaultValue"])
                ]),
                _: 1
              }, 8, ["locked"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_ReadonlyField, {
              class: "flex justify-between align-center panel panel-cmp",
              locked: _ctx.state.taskConfiguration!.originValue?.notify_late_lock
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.Lang.getI18N("notify-late")), 1),
                  _createVNode(_component_ToggleSwitch, {
                    defaultValue: _ctx.state.taskConfiguration!.getNotifyLate(),
                    modelValue: _ctx.state.taskConfiguration!.notify_late,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.taskConfiguration!.notify_late) = $event))
                  }, null, 8, ["defaultValue", "modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["locked"]),
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.state.taskConfiguration!.originValue?.recurrence_lock,
              class: "flex justify-between align-center panel panel-cmp"
            }, {
              default: _withCtx(() => [
                _hoisted_26,
                _createVNode(_component_SeButton, {
                  icon: "/ico/edit.svg",
                  onPress: _ctx.openRRuleModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.rruleText), 1)
                  ]),
                  _: 1
                }, 8, ["onPress"])
              ]),
              _: 1
            }, 8, ["locked"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_ReadonlyField, {
              class: "flex justify-between align-center panel panel-cmp",
              locked: _ctx.state.taskConfiguration!.originValue?.automatically_postponed_lock
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.Lang.getI18N("automatically-postponed")), 1),
                  _createVNode(_component_ToggleSwitch, {
                    defaultValue: _ctx.state.taskConfiguration!.getAutomaticallyPostponed(),
                    modelValue: _ctx.state.taskConfiguration!.automatically_postponed,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.taskConfiguration!.automatically_postponed) = $event))
                  }, null, 8, ["defaultValue", "modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["locked"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_ReadonlyField, {
                  class: "p0y",
                  locked: !_ctx.state.creation
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeDropdown, {
                      defaultTitle: _ctx.Lang.getI18N('task-configuration.select-module')
                  ,
                      titleFunc: (value) => _ctx.Lang.getI18N(value),
                      onSelectionChanged: _ctx.onModuleChange,
                      modelValue: _ctx.state.selectedModule,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.selectedModule) = $event)),
                      autoResizeMenu: false,
                      ref: "module"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SeDropdownItem, {
                          value: _ctx.ModuleEnum.Temperatures
                        }, null, 8, ["value"]),
                        _createVNode(_component_SeDropdownItem, {
                          value: _ctx.ModuleEnum.Action
                        }, null, 8, ["value"]),
                        _createVNode(_component_SeDropdownItem, {
                          value: _ctx.ModuleEnum.Oils
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["defaultTitle", "titleFunc", "onSelectionChanged", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["locked"])
              ]),
              (_ctx.state.selectedModule == _ctx.ModuleEnum.Temperatures || _ctx.state.selectedModule! == _ctx.ModuleEnum.Oils)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.Lang.getI18N("elements")), 1),
                        _createElementVNode("div", _hoisted_37, [
                          _withDirectives(_createVNode(_component_Badge, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Auto")
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.isAutomaticTask()]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ReadonlyField, {
                          locked: _ctx.state.taskConfiguration!.originValue?.configuration_lock
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SeButton, {
                              onPress: _ctx.openAddElementModal,
                              icon: "/ico/edit.svg"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("modify")), 1)
                              ]),
                              _: 1
                            }, 8, ["onPress"])
                          ]),
                          _: 1
                        }, 8, ["locked"])
                      ])
                    ]),
                    _createVNode(_component_ReadonlyField, {
                      class: "grid single grid-overflow",
                      locked: _ctx.state.taskConfiguration!.originValue?.configuration_lock
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedElements, (item) => {
                          return (_openBlock(), _createBlock(_component_WideCard, {
                            class: "shadow",
                            key: item.ref!.id,
                            obj: item,
                            title: item.getName(),
                            ref_for: true,
                            ref: "items",
                            icon: item.getIllustrationUrl() != null
                    ? item.getIllustrationUrl()
                    : '/ico/equipement.svg'
                    
                          }, {
                            footer: _withCtx(() => [
                              _hoisted_39
                            ]),
                            _: 2
                          }, 1032, ["obj", "title", "icon"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["locked"])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.state.selectedModule == _ctx.ModuleEnum.Action)
                ? (_openBlock(), _createBlock(_component_ReadonlyField, {
                    key: 1,
                    locked: _ctx.state.taskConfiguration!.originValue?.configuration_lock
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.Lang.getI18N("subtasks")), 1),
                        _createVNode(_component_SeButton, {
                          onPress: _ctx.openAddActionModal,
                          icon: "/ico/plus.svg"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add")), 1)
                          ]),
                          _: 1
                        }, 8, ["onPress"])
                      ]),
                      _createVNode(_component_TaskActionList, {
                        class: "grow grid-overflow",
                        editClick: _ctx.openModifyActionModal,
                        deleteClick: _ctx.removeAction,
                        actions: _ctx.taskActions
                      }, null, 8, ["editClick", "deleteClick", "actions"])
                    ]),
                    _: 1
                  }, 8, ["locked"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.state.taskConfiguration!.originValue?.schedule_lock,
              class: "panel flex col g12 panel-cmp"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.Lang.getI18N("schedule")), 1),
                  _createVNode(_component_SeButton, {
                    onPress: _ctx.openAddScheduleModal,
                    icon: "/ico/plus.svg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules, (schedule, index) => {
                    return (_openBlock(), _createBlock(_component_WideCard, {
                      class: "shadow",
                      key: index,
                      obj: schedule,
                      title: _ctx.dateFormat(
                _ctx.DateUtils.getDateFromMinutes(schedule.start - 60),
                'HH:MM'
              ) +
                '-' +
                _ctx.dateFormat(
                  _ctx.DateUtils.getDateFromMinutes(schedule.end - 60),
                  'HH:MM'
                )
                ,
                      icon: "/ico/calendar.svg",
                      onClick: ($event: any) => (_ctx.openEditScheduleModal(schedule))
                    }, {
                      body: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_SeFadeButton, {
                            onClick: [
                              _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                              ($event: any) => (_ctx.removeSchedule(schedule))
                            ],
                            icon: "/ico/trash.svg",
                            text: "Delete"
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      footer: _withCtx(() => []),
                      _: 2
                    }, 1032, ["obj", "title", "onClick"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["locked"])
          ])
        ])
      ])
    ])
  ], 64))
}